import React from 'react';
import { Box, Grid, KeyValue, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';
import { useStyles } from './style';

interface CEQScoreProps {
  overall: string;
  listening: string;
  speaking: string;
  reading: string;
  writing: string;
}

const CEQScore = ({ score }: { score: CEQScoreProps }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { overall, listening, writing, speaking, reading } = score;

  return (
    <Box className={`${classes.container} ${classes.marginTop1}`}>
      <Typography variant="h3" className={classes.subheader}>
        {t('exam->>NonNationalExam.CEQScores')}
      </Typography>

      <Grid container spacing={2}>
        <Grid md={12} xs={12}>
          <KeyValue keyText={t('exam->>NonNationalExam.Overall')} valueText={overall} />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid md={6} xs={12}>
          <KeyValue keyText={t('exam->>RegistrationSummary.Reading')} valueText={reading} />
        </Grid>
        <Grid md={6} xs={12}>
          <KeyValue keyText={t('exam->>NonNationalExam.Listening')} valueText={listening} />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid md={6} xs={12}>
          <KeyValue keyText={t('exam->>NonNationalExam.Writing')} valueText={writing} />
        </Grid>
        <Grid md={6} xs={12}>
          <KeyValue keyText={t('exam->>NonNationalExam.Speaking')} valueText={speaking} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CEQScore;
